
import * as api from '../apirest/index';

const URL_FIND_USER = '/users/findById?idAuth=:id';


export const getLoggedUser = async (uid) => {
    let url = URL_FIND_USER.replace(':id', uid);
    let user = null;
    const res = await api.get(url, {});
    if (res?.data) {
        user = res?.data?.doc;
    }

    return user
}